export const fiscalData = {
	title: "DATOS FISCALES",
	fields: {
		ncm: {
			label: "NCM",
			placeholder: "Introducir NCM",
			tooltip: "Nomenclatura Común del Mercosur",
		},
		cest: {
			label: "CEST",
			placeholder: "Introducir CEST",
			tooltip: "Código Especificador de Sustitución Tributaria",
		},
		fiscalProfile: {
			label: "Perfil fiscal",
			placeholder: "Seleccionar perfil fiscal",
			loading: "Cargando...",
			tooltip:
				"Conjunto de datos que describe la situación fiscal de una persona o empresa.",
		},
		fiscalGroup: {
			label: "Grupo fiscal",
			placeholder: "Seleccionar grupo fiscal",
			loading: "Cargando...",
			tooltip: "Grupo fiscal es un código que clasifica productos según su tributación.",
		},
	},
};
